<template>
  <div>
    <Head title="合作提案" />
    <ScrollTop />

    <div class="w-full mt-5">
      <figure class="my-16">
        <a
          target="_blank"
          alt="寄信給我們"
          title="寄信給我們"
          href="mailto:purchase@foody-home.com"
          ><img src="/images/factory01_01.jpg"
        /></a>
        <a
          target="_blank"
          alt="加入LINE好友"
          title="加入LINE好友"
          href="https://lin.ee/N6vpYOH"
          ><img src="/images/factory01_02.jpg"
        /></a>
      </figure>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import ScrollTop from "primevue/scrolltop";

export default {
  components: { ScrollTop },
  layout: Layout,
  data() {
    return {
      activeIndex: 0,
    };
  },
  methods: {
    //
  },
  mounted() {
    //
  },
};
</script>

<style scoped>
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

li {
  margin-top: 2rem;
  margin-bottom: 2rem;
  line-height: 2;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table,
th,
td {
  border: 1px solid rgb(0, 0, 0);
  padding: 0.5rem;
  text-align: left;
  width: 24em;
}

* {
  font-family: "Noto Sans TC", sans-serif;
}

p {
  font-size: 1.25rem;
  line-height: 2;
  color: rgb(122, 119, 116);
}

h1 {
  font-size: 2.25rem;
  margin: 0.67rem 0;
  font-weight: 700;
}

h2 {
  font-size: 1.875rem;
  margin: 0.67rem 0;
  font-weight: 700;
}

h3 {
  font-size: 1.5rem;
  margin: 0.67rem 0;
  font-weight: 700;
}
</style>